export { default, type TreeProps } from './Tree';
